import { ConfirmationOfSigning } from './ConfirmationOfSigning'

export default ConfirmationOfSigning
